export default __webpack_public_path__ + "static/media/mexc_logo.c4180994.jpg";